<template>
  <div class="progress-checkbox-container" :class="className">
    <div class="check-mark-item completed" v-if="isCompleted">
      <Icon icon="check" class="white"/>
    </div>
    <div class="check-mark-item current" v-if="!isCompleted && isCurrent">
      <div class="empty-placeholder"></div>
    </div>
    <div class="check-mark-item" v-if="!isCompleted && !isCurrent">
      <div class="empty-placeholder"></div>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component'
import Vue from 'vue'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon
  },
  props: {
    isLast: {
      type: Boolean,
      default: false
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isCompleted: {
      type: Boolean,
      default: false
    },
    isCurrent: {
      type: Boolean,
      default: false
    }
  }
})
export default class ProgressCheckbox extends Vue {
  get className () {
    let className = ''
    if (this.$props.isFirst) {
      className += ' first'
    }
    if (this.$props.isLast) {
      className += ' last'
    }
    return className
  }
}
</script>

<style lang="scss" scoped>
.progress-checkbox-container {
  cursor: pointer;
  min-height: 28px;
  width: 28px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  position: relative;
  .check-mark-item {
    width: 24px;
    height: 24px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.completed {
      background-color: var(--status-progress-color);
    }
    &.current {
      border: 1px solid var(--status-progress-color);
    }
    .empty-placeholder {
      width: 16px;
      height: 16px;
      border-radius: 16px;
      border: 1px solid var(--primary-border-color);
    }
  }
  &::before {
    content: '';
    position: absolute;
    left: 11px;
    top: -10px;
    width: 2px;
    background: #D1D1E5;
    height: 10px;
  }
  &::after {
    content: '';
    position: absolute;
    left: 11px;
    top: 30px;
    width: 2px;
    background: #D1D1E5;
    height: 10px;
  }
  &.last::after{
    width: 0;
    height: 0;
  }
  &.first::before {
    width: 0;
    height: 0;
  }
}
</style>
